import type { Messages } from "./en";

export const mr: Messages = {
  app: {
    name: "स्मार्ट क्रॉप प्रोटेक्ट",
    tagline: "तुमच्या शेताचा अंदाज",
    offline: "तुम्ही ऑफलाइन आहात. जतन केलेला डेटा दाखवत आहोत.",
    updated: (t) => `${t} अद्ययावत`,
    staleData: "नवीन माहिती मिळाली नाही. शेवटचा जतन केलेला अंदाज दाखवत आहोत.",
    loading: "लोड होत आहे…",
    retry: "पुन्हा प्रयत्न करा",
    error: "काहीतरी चुकले.",
    readAloud: "वाचून दाखवा",
    voice: "आवाजाने चालवा",
    listening: "ऐकत आहोत… बोला: हवामान, स्कॅन, पैसे, नियोजन किंवा होम",
    notHeard: "आवाज ऐकू आला नाही. पुन्हा बोला.",
    voiceUnsupported: "या ब्राउझरमध्ये आवाजाने चालवण्याची सोय नाही.",
    speechUnsupported: "या फोनवर वाचून दाखवण्याची सोय नाही.",
    change: "बदला",
    save: "जतन करा",
    cancel: "रद्द करा",
    close: "बंद करा",
    next: "पुढे",
    back: "मागे",
    done: "झाले",
    seeAll: "सर्व पहा",
    viewTable: "तक्त्यात पहा",
    viewChart: "आलेखात पहा",
    source: "स्रोत",
    disclaimer:
      "हे सर्वसाधारण मार्गदर्शन आहे. औषध व मात्रेसाठी उत्पादनाचे लेबल आणि तुमचे कृषी अधिकारी किंवा कृषी विज्ञान केंद्र यांचा सल्ला पाळा.",
  },
  nav: {
    today: "आज",
    field: "शेत",
    scan: "स्कॅन",
    money: "पैसे",
    plan: "नियोजन",
    learn: "माहिती",
    ai: "AI कसे काम करते",
    settings: "सेटिंग्ज",
  },
  greet: { morning: "सुप्रभात", afternoon: "नमस्कार", evening: "शुभ संध्याकाळ" },
  units: {
    mm: "मिमी",
    kmh: "किमी/तास",
    c: "°C",
    kgha: "किलो/हेक्टर",
    tha: "टन/हेक्टर",
    qacre: "क्विंटल/एकर",
    acres: "एकर",
    perQuintal: "प्रति क्विंटल",
    perKg: "प्रति किलो",
    days: (n) => `${n} दिवस`,
    hours: (n) => `${n} तास`,
  },
  level: {
    good: "चांगले",
    marginal: "बरे",
    poor: "योग्य नाही",
    none: "नाही",
    low: "कमी",
    moderate: "मध्यम",
    high: "जास्त",
    warning: "इशारा",
    serious: "गंभीर",
    critical: "अतिगंभीर",
  },
  stage: {
    presowing: "अजून पेरणी झालेली नाही",
    initial: "उगवण व रुजणे",
    development: "वाढ",
    mid: "फुलोरा व दाणे/फळ भरणे",
    late: "पक्वता",
    harvest: "काढणीस तयार",
    day: (n) => `${n}वा दिवस`,
    sowsIn: (n) => `${n} दिवसांत पेरणी`,
    harvestIn: (n) => `साधारण ${n} दिवसांत काढणी`,
    harvestOn: (d) => `अंदाजे काढणी ${d}`,
  },
  onboarding: {
    welcomeTitle: "आत्मविश्वासाने शेती करा",
    welcomeBody:
      "तुमच्या स्वतःच्या शेतासाठी हवामान, पाणी, कीड-रोग धोका आणि बाजारभावाचा अंदाज. सरकारी पीक आकडेवारी आणि उपग्रह हवामानावर आधारित. इंटरनेटशिवायही चालते, आणि तुमची माहिती तुमच्या फोनमध्येच राहते.",
    start: "सुरू करा",
    languageTitle: "तुमची भाषा निवडा",
    locationTitle: "तुमचे शेत कुठे आहे?",
    locationBody: "तुमचे ठिकाण फक्त हवामान व मातीची माहिती आणण्यासाठी वापरले जाते. ते याच फोनमध्ये राहते.",
    useGps: "माझे ठिकाण शोधा",
    locating: "तुमचे ठिकाण शोधत आहोत…",
    orChoose: "किंवा तुमचा जिल्हा निवडा",
    state: "राज्य",
    district: "जिल्हा",
    gpsFailed: "ठिकाण सापडले नाही. कृपया तुमचा जिल्हा निवडा.",
    outsideIndia: "हे अॅप भारतासाठी आहे. कृपया जिल्हा निवडा.",
    cropTitle: "तुम्ही काय पिकवता?",
    season: "हंगाम",
    sowingDate: "पेरणीची तारीख",
    fieldTitle: "तुमच्या शेताविषयी",
    area: "शेताचे क्षेत्र",
    irrigation: "पाण्याचा स्रोत",
    ready: "सर्व तयार",
    readyBody: "तुमच्या शेताचा डॅशबोर्ड तयार आहे.",
  },
  irrigationMethod: {
    rainfed: "फक्त पाऊस",
    flood: "कालवा / पाटपाणी",
    sprinkler: "तुषार (स्प्रिंकलर)",
    drip: "ठिबक",
  },
  today: {
    title: "आज",
    irrigation: "सिंचन",
    spraying: "फवारणी",
    pestRisk: "कीड व रोग धोका",
    cropStage: "पिकाची अवस्था",
    alerts: "हवामान इशारे",
    noAlerts: "या आठवड्यात कोणताही हवामान इशारा नाही.",
    week: "पुढील 7 दिवस",
    outlook: "उत्पादन व भावाचा अंदाज",
    tasks: "पुढील कामे",
    tip: "आजचा सल्ला",
    setLocation: "अंदाजासाठी तुमच्या शेताचे ठिकाण निवडा.",
  },
  irrigate: {
    now: (mm) => `आज पाणी द्या: साधारण ${mm} मिमी`,
    by: (d) => `${d} पर्यंत पाणी द्या`,
    byAmount: (mm, l) => `साधारण ${mm} मिमी (एकरी ${l} लिटर)`,
    hold: (mm, d) => `थांबा: ${d} दिवसांत ${mm} मिमी पावसाची शक्यता`,
    ok: "आता पाण्याची गरज नाही",
    okSub: (p) => `मुळांचा भाग ${100 - p}% भरलेला आहे`,
    rainfedStress: (d) => `${d} पासून पाण्याचा ताण शक्य`,
    rainfedSub: "आच्छादनाने ओलावा टिकवा; शक्य असल्यास संरक्षित पाणी द्या.",
    notSown: "शेतात अजून पेरणी झालेली नाही",
    harvest: "पीक तयार आहे; पाणी देणे थांबवा",
    riceFlooded: "शेतात 2–5 सेमी पाणी ठेवा",
    riceAwd: (n) => `साधारण 5 सेमी पाणी भरा: ${n} दिवस चांगला पाऊस नाही`,
    riceAwdSub: "आलटून पालटून ओले-कोरडे केल्याने उत्पादन न घटता साधारण 25% पाणी वाचते.",
    riceDrain: "पाणी काढून टाका: काढणी जवळ आहे",
    logged: "पाणी दिल्याची नोंद झाली",
    logToday: "मी आज पाणी दिले",
  },
  spray: {
    goodNow: "आता फवारणीसाठी चांगली वेळ आहे",
    window: (a, b) => `सर्वोत्तम वेळ: ${a}–${b}`,
    none: "2 दिवसांत फवारणीसाठी सुरक्षित वेळ नाही",
    noneSub: "पाऊस, वारा किंवा उष्णतेची शक्यता. पुढील अंदाजाची वाट पाहा.",
    reason: {
      "rain-now": "पाऊस पडत आहे",
      "rain-soon": "4 तासांत पाऊस",
      "wind-high": "जोराचा वारा: औषध उडून जाईल",
      "wind-calm": "अजिबात वारा नाही: औषध हवेत तरंगेल",
      hot: "खूप उष्णता",
      "dry-air": "कोरडी हवा: थेंब उडून जातील",
      humid: "खूप दमट: उशिरा सुकेल",
      dark: "अंधार",
    },
    planner: "फवारणी नियोजन",
    plannerSub: "पुढील 48 तास: पाऊस, वारा, उष्णता आणि डेल्टा-T तपासून.",
  },
  risk: {
    none: "या आठवड्यात धोका कमी",
    noneSub: "हवामान मोठ्या प्रादुर्भावासाठी अनुकूल नाही.",
    title: "कीड व रोग धोका",
    sub: "तासागणिक आर्द्रता, पानांचा ओलावा व तापमानावरून संसर्गाचा धोका.",
    peak: (d) => `${d} रोजी सर्वाधिक`,
    driver: {
      wetness: "पाने दीर्घकाळ ओली",
      "warm-humid": "उष्ण व दमट",
      "hot-dry": "उष्ण व कोरडे",
      "cool-humid": "थंड व दमट",
      "rain-wind": "पाऊस व वारा",
      warm: "उष्ण हवामान",
    },
  },
  alert: {
    heat: (v) => `उष्णतेची लाट: ${v}°C पर्यंत. संध्याकाळी पाणी द्या, दुपारी फवारणी टाळा.`,
    cold: (v) => `थंड रात्री, ${v}°C पर्यंत. हलके पाणी पिकाचे संरक्षण करते.`,
    frost: (v) => `दव/हिम पडण्याचा धोका: ${v}°C. संध्याकाळी हलके पाणी द्या; रोपवाटिका झाका.`,
    "heavy-rain": (v) => `मुसळधार पाऊस: एका दिवसात ${v} मिमी. चर उघडा; खत व फवारणी पुढे ढकला.`,
    wind: (v) => `${v} किमी/तास पर्यंत जोराचा वारा. उंच पिकांना आधार द्या; फवारणी करू नका.`,
    storm: () => "वादळी पावसाची शक्यता. वीज चमकताना मोकळ्या शेतात थांबू नका.",
    hail: () => "गारपीट होऊ शकते. पक्व पीक काढा आणि धान्य सुरक्षित ठेवा.",
    "dry-spell": (v) => `${v} दिवस उपयुक्त पाऊस नाही. पाण्याचे नियोजन करा व आच्छादन करा.`,
  },
  field: {
    title: "शेत",
    sub: "तुमच्या पिकासाठी हवामान, पाणी आणि संरक्षण.",
    forecast: "10 दिवसांचा अंदाज",
    temperature: "तापमान",
    rainfall: "पाऊस",
    rainChance: (p) => `${p}% शक्यता`,
    max: "कमाल",
    min: "किमान",
    waterTitle: "मातीतील पाणी",
    waterSub: "तुमच्या मुळांच्या भागाचे FAO-56 जलसंतुलन: मागील 14 दिवस आणि अंदाज.",
    depletion: "मुळांसाठी उपलब्ध पाणी",
    raw: "ताण सुरू",
    taw: "रिकामे",
    irrigationTitle: "सिंचन सल्ला",
    soilTitle: "तुमची माती",
    soilFrom: "ISRIC SoilGrids (250 मीटर) वरून",
    soilManual: "तुम्ही निवडलेल्या प्रकाराची सर्वसाधारण माती",
    texture: "पोत",
    ph: "सामू (pH)",
    awc: "पाणी धरून ठेवण्याची क्षमता",
    organicCarbon: "सेंद्रिय कर्ब",
    phOk: "सामू या पिकासाठी योग्य आहे",
    phLow: "या पिकासाठी आम्लधर्मी: माती परीक्षणानंतर चुना देण्याचा विचार करा",
    phHigh: "या पिकासाठी विम्लधर्मी: माती परीक्षणानंतर सेंद्रिय खत किंवा जिप्सम द्या",
    today: "आज",
    tomorrow: "उद्या",
    wind: "वारा",
    humidity: "आर्द्रता",
  },
  scan: {
    title: "पीक डॉक्टर",
    sub: "पानाचा फोटो घ्या किंवा जे दिसते ते सांगा. तपासणी तुमच्या फोनवरच होते.",
    photoTab: "फोटो",
    symptomsTab: "लक्षणे",
    take: "फोटो घ्या किंवा निवडा",
    trySample: "पान जवळ नाही? नमुना फोटो वापरून पाहा:",
    tips: "एक रोगट पान पूर्ण फ्रेममध्ये, दिवसाच्या उजेडात, स्पष्ट फोटो घ्या.",
    analyze: "फोटो तपासा",
    analyzing: "तपासणी सुरू आहे…",
    loadingModel: "AI मॉडेल लोड होत आहे (फक्त पहिल्यांदा)…",
    modelUnavailable: "पानाचे AI मॉडेल अजून उपलब्ध नाही. फक्त नुकसानीचा नकाशा दाखवत आहोत.",
    results: "निकाल",
    likely: "सर्वाधिक शक्यता",
    possible: "हेही शक्य",
    confidence: (p) => `${p}% खात्री`,
    unsure: "खात्रीने सांगता येत नाही. एका पानाचा जवळून स्पष्ट फोटो घ्या.",
    notLeaf: "हे पान वाटत नाही. एक रोगट पान पूर्ण फ्रेममध्ये घेऊन पुन्हा प्रयत्न करा.",
    cropNotCovered:
      "फोटो मॉडेल भात, मका, कापूस, भुईमूग, बटाटा व टोमॅटोसाठी आहे. या पिकासाठी 'लक्षणे' टॅब अधिक विश्वसनीय आहे.",
    healthy: "निरोगी दिसते",
    verify:
      "शेतातील फोटो प्रयोगशाळेतील फोटोंपेक्षा अवघड असतात: फवारणीपूर्वी खालील लक्षणे तुमच्या पानाशी जुळतात का ते तपासा.",
    otherCrop: (c) => `हे ${c} वाटते, तुम्ही निवडलेले पीक नाही.`,
    severity: "पानाचा खराब झालेला भाग",
    severityNote: "पानाच्या रंगावरून अंदाज. तपकिरी व पिवळे भाग दाखवले आहेत.",
    whatToDo: "काय करावे",
    signs: "कसे ओळखावे",
    favours: "कोणत्या हवामानात वाढते",
    cultural: "शेतातील उपाय",
    biological: "सेंद्रिय व जैविक उपाय",
    chemical: "रासायनिक (लेबलनुसार)",
    pickSymptoms: "तुम्हाला काय दिसते?",
    findCauses: "संभाव्य कारणे शोधा",
    clear: "साफ करा",
    noMatch: "शेतात दिसणारे किमान एक लक्षण निवडा.",
    matched: "जुळणारी लक्षणे",
    weatherBoost: "या आठवड्याचे हवामान याला अनुकूल आहे",
    saved: "शेत डायरीत जतन केले",
    saveLog: "शेत डायरीत जतन करा",
    log: "शेत डायरी",
    logEmpty: "तुमचे जतन केलेले स्कॅन येथे दिसतील आणि इंटरनेटशिवायही मिळतील.",
    privacy: "फोटो तुमच्या फोनबाहेर जात नाहीत.",
  },
  symptom: {
    spots: "पानांवर ठिपके",
    "eye-lesions": "डोळ्यासारखे ठिपके, मध्यभागी राखाडी",
    "concentric-rings": "निशाणासारखी वर्तुळे असलेले ठिपके",
    "rust-pustules": "गंजासारख्या नारिंगी भुकटीच्या पुटकुळ्या",
    powder: "पानांवर पांढरी भुकटी",
    "water-soaked": "गडद, पाण्याने भिजल्यासारखे डाग",
    "white-mould-under": "पानाखाली पांढरी/राखाडी बुरशी",
    "purple-patches": "जांभळे चट्टे",
    "leaf-tip-dry": "पानांची टोके/कडा वाळणे",
    yellowing: "पाने पिवळी पडणे",
    mosaic: "पिवळा-हिरवा चट्टेरी नमुना",
    "leaf-curl": "पाने मुरडणे किंवा आकसणे",
    silvering: "चंदेरी रेषा",
    wilting: "ओल्या जमिनीतही झाड मलूल",
    stunting: "झाडाची वाढ खुंटणे",
    "rotting-stem": "खोड किंवा मुळाजवळ कुजणे",
    holes: "पानांना छिद्रे किंवा कुरतडलेली पाने",
    frass: "पोंग्यात भुशासारखी विष्ठा",
    "bored-fruit": "शेंगा, बोंडे किंवा फळांना छिद्रे",
    "dead-heart": "मधला कोंब वाळणे",
    "sticky-insects": "लहान किडे, चिकट पाने",
    webbing: "बारीक जाळी",
    "dry-cracked": "करपलेली पाने, भेगाळलेली कोरडी जमीन",
    "standing-water": "शेतात पाणी साचले, मुळे कुजणे",
    lodged: "झाडे जमिनीवर लोळली",
    weeds: "खूप तण",
    "mouldy-grain": "बुरशी लागलेले किंवा खराब धान्य",
    trampled: "जनावरांनी तुडवले किंवा खाल्ले",
  },
  kind: {
    all: "सर्व",
    fungal: "बुरशी",
    bacterial: "जिवाणू",
    viral: "विषाणू",
    insect: "कीड",
    mite: "कोळी",
    abiotic: "हवामान व माती",
  },
  money: {
    title: "उत्पादन आणि पैसे",
    sub: "जिल्ह्याच्या उत्पादनाचा अंदाज, बाजाराचा कल आणि हमीभाव.",
    yieldTitle: "अपेक्षित उत्पादन",
    yieldSub: (d) => `${d} जिल्ह्यासाठी मशीन लर्निंग अंदाज`,
    range: (a, b) => `संभाव्य श्रेणी ${a} – ${b}`,
    vsNormal: (p) =>
      p >= 0 ? `तुमच्या जिल्ह्याच्या सरासरीपेक्षा ${p}% जास्त` : `तुमच्या जिल्ह्याच्या सरासरीपेक्षा ${-p}% कमी`,
    basedOn: (k, n) =>
      k === 0
        ? "हंगामापूर्वी: जिल्ह्याचा इतिहास व सर्वसाधारण हवामानावर आधारित"
        : `या हंगामातील ${n} पैकी ${k} महिन्यांचे हवामान समाविष्ट`,
    rainSoFar: (p) => `आतापर्यंतचा पाऊस: सरासरीच्या ${p}%`,
    scenarioTitle: "जर उरलेला हंगाम असेल…",
    dry: "कोरडा",
    normal: "सर्वसाधारण",
    wet: "जास्त पाऊस",
    history: "जिल्ह्याचे उत्पादन",
    forecastMark: "अंदाज",
    noYieldData: "या पिकाची व हंगामाची जिल्हा आकडेवारी नाही, म्हणून उत्पादन अंदाज नाही.",
    tomatoNote: "सरकारी जिल्हा आकडेवारीत अजून हे पीक समाविष्ट नाही.",
    incomeTitle: "उत्पन्नाचा अंदाज",
    incomeSub: "शेताचे क्षेत्र × अपेक्षित उत्पादन × भाव.",
    production: "अपेक्षित उत्पादन",
    priceUsed: "वापरलेला भाव",
    grossIncome: "एकूण उत्पन्न",
    mspLabel: (s) => `हमीभाव ${s}`,
    marketLabel: "बाजारभाव (अंदाज)",
    pricesTitle: "बाजारभावाचा कल",
    pricesSub: (z) => `${z} विभागातील किरकोळ भाव, 80% अंदाज श्रेणीसह`,
    latest: (m) => `शेवटची नोंद (${m})`,
    expected: (m) => `${m} मध्ये अपेक्षित`,
    noPrice: "या पिकाच्या बाजारभावाची आकडेवारी नाही. खाली बाजार समितीचे ताजे भाव पहा.",
    retailNote: "किरकोळ भाव बाजाराची दिशा दाखवतात; बाजार समितीत तुम्हाला मिळणारा भाव कमी असतो.",
    mandiTitle: "आजचे बाजार समिती दर",
    mandiSub: (d) => `अॅगमार्कनेट घाऊक दर, ${d} अद्ययावत`,
    modal: "सर्वसाधारण दर",
    mspTitle: "किमान आधारभूत किंमत (हमीभाव)",
    mspNone: "या पिकासाठी हमीभाव जाहीर नाही.",
    helpTitle: "विक्री, विमा आणि मदत",
    agmarknet: "बाजार समितीचे ताजे भाव (अॅगमार्कनेट)",
    enam: "ऑनलाइन विक्री (ई-नाम)",
    pmfby: "पीक विमा (PMFBY)",
    kvk: "तुमचे कृषी विज्ञान केंद्र शोधा",
    kcc: "किसान कॉल सेंटर 1800-180-1551",
    zone: { north: "उत्तर", south: "दक्षिण", east: "पूर्व", west: "पश्चिम", northeast: "ईशान्य" },
  },
  plan: {
    title: "हंगामाचे नियोजन",
    sub: "पिकाची कालरेषा, कामे आणि पुढील हंगामाचे पर्याय.",
    timeline: "पिकाची कालरेषा",
    sowing: "पेरणी",
    harvest: "काढणी",
    tasksTitle: "कामांची यादी",
    addTask: "तुमचे काम जोडा",
    addPlaceholder: "उदा.: उत्तरेकडील शेतात निंबोळी फवारा",
    add: "जोडा",
    advisorTitle: "पुढील हंगामात काय पिकवावे",
    advisorSub: (s, d) => `${d} मध्ये ${s} साठी एकरी अपेक्षित उत्पन्नानुसार पिके`,
    expectedYield: "अपेक्षित उत्पादन",
    perAcre: "एकरी उत्पन्न",
    risk: "वाईट वर्षी",
    noAdvisor: "पिकांची तुलना करण्यासाठी जिल्ह्याची पुरेशी आकडेवारी नाही.",
    stageTasks: {
      initial: [
        "जिथे रोपे उगवली नाहीत तिथे नांगे भरा",
        "पेरणीनंतर 20–25 दिवसांनी पहिली खुरपणी",
        "लहान रोपांवर कीड व मर रोग तपासा",
      ],
      development: ["माती परीक्षणानुसार नत्र द्या", "दुसरी खुरपणी किंवा कोळपणी", "आठवड्यातून दोनदा कीड पाहा"],
      mid: ["फुलोऱ्यात पिकाला पाण्याचा ताण देऊ नका", "फुले व दाणे/शेंगा किडीपासून वाचवा", "कामगंध सापळे व पक्षी थांबे लावा"],
      late: [
        "काढणीपूर्वी 10–15 दिवस पाणी बंद करा",
        "काढणीसाठी मजूर किंवा यंत्र ठरवा",
        "साठवणूक जागा स्वच्छ करा; पोती तपासा",
      ],
      presowing: ["माती परीक्षण करून घ्या", "शिफारस केलेल्या वाणाचे प्रमाणित बियाणे घ्या", "पाणी निचऱ्यासाठी चर काढा"],
      harvest: [
        "साठवणुकीपूर्वी उत्पादन चांगले वाळवा",
        "विक्रीपूर्वी बाजारभाव पाहा",
        "पिकाचे अवशेष सुरक्षित काढा; जाळू नका",
      ],
    },
  },
  learn: {
    title: "माहिती",
    sub: "कीड, रोग आणि पीक नुकसानीची इतर कारणे, व त्यांचे व्यवस्थापन.",
    search: "कीड व रोग शोधा",
    forCrop: (c) => `${c} साठी धोके`,
    allCrops: "सर्व पिके",
  },
  settings: {
    title: "सेटिंग्ज",
    profile: "तुमचे शेत",
    location: "ठिकाण",
    crop: "पीक",
    language: "भाषा",
    theme: "स्वरूप",
    themeSystem: "फोननुसार",
    themeLight: "फिकट",
    themeDark: "गडद",
    textSize: "अक्षरांचा आकार",
    soil: "मातीचा प्रकार",
    soilAuto: "आपोआप (SoilGrids)",
    soilSandy: "वालुकामय",
    soilLoamy: "पोयट्याची",
    soilClay: "चिकणमाती",
    soilBlack: "काळी कापसाची जमीन",
    privacy: "गोपनीयता",
    privacyBody:
      "सर्व काही याच फोनमध्ये राहते. हवामान, माती आणि उपग्रह माहिती फक्त तुमच्या शेताच्या निर्देशांकांवरून सार्वजनिक सेवांकडून आणली जाते. खाते नाही, ट्रॅकिंग नाही.",
    reset: "सर्व माहिती पुसा",
    resetConfirm: "या फोनमधून शेताची माहिती, कामे आणि जतन केलेले स्कॅन पुसायचे?",
    about: "माहिती",
    version: (v) => `आवृत्ती ${v}`,
  },
  tips: [
    "सकाळी लवकर शेत पाहा, तेव्हा कीड सहज दिसते.",
    "झाडाच्या बुंध्याशी पाणी द्या म्हणजे पाने कोरडी राहून रोग कमी होतात.",
    "प्रत्येक हंगामात पिकांची फेरपालट करा म्हणजे कीड-रोगांचे चक्र तुटते.",
    "अवजारे स्वच्छ ठेवा म्हणजे रोग एका शेतातून दुसऱ्यात पसरत नाही.",
    "पानांच्या खालच्या बाजूला पाहा, अनेक किडी तिथे लपतात.",
    "साठवणुकीपूर्वी धान्य पूर्ण वाळवा.",
    "बांध तणमुक्त ठेवा, त्यात किडी लपतात.",
  ],
  months: ["जाने", "फेब्रु", "मार्च", "एप्रि", "मे", "जून", "जुलै", "ऑग", "सप्टें", "ऑक्टो", "नोव्हें", "डिसें"],
};
